<template>
  <div>
    <div class="form-group">
      <div class="col-sm-12">
        <transition name="el-fade-in-linear" mode="out-in">
          <div v-if="foundNone">
            <div
              data-notify="container"
              class="col-md-12 alert alert-warning alert-with-icon "
            >
              <span data-notify="icon" class="fa fa-exclamation"></span>
              <span data-notify="message"  v-if="!$store.getters.isIndividual">
                No institutes found, please refine your search by entering a <strong>'key word'</strong> from the name of the institute and filter the results by country.<br/>
                For example, if you are looking for Universidade Tuiuti do Parana - <strong>Tuiuti</strong> would be a good key word.<br/><br/>
                If you still can't locate the institute you are looking for, click on 'Request a new institute' below.
                </span>
              <span data-notify="message" v-else>
                No institutes found, please refine your search by entering a <strong>'key word'</strong> from the name of the institute and filter the results by country.<br/>
                For example, if you are looking for Universidade Tuiuti do Parana - <strong>Tuiuti</strong> would be a good key word.<br/><br/>
                If you still can't locate the institute you are looking for, please contact Qualification Check at <b><u><a href="mailto:newinstitute@qualificationcheck.com" style="color:black">newinstitute@qualificationcheck.com</a></u></b>.
                </span>
            </div>
            <div v-if="!$store.getters.isIndividual"><button @click.prevent="requestInstitute" type="button" class="btn btn-wd">Request a new institute</button></div>
          </div>
          <el-table
            v-else
            class="table table-striped table-no-bordered table-hover"
            ref="instituteTable"
            :data="results"
            v-loading="loading"
            element-loading-spinner="qc-spinner"
            highlight-current-row
            @current-change="selectByRow"
            size="mini"
            style="width: 100%"
            tooltip-effect="light"
            :class="{ warning: selectionWarning }"
          >
            <span slot="empty"
              >No institutes, start typing above to search.</span
            >
            <el-table-column
              label="Name"
              :show-overflow-tooltip="true"
              min-width="250"
            >
              <template slot-scope="props">
                <div v-if="props.row.names && props.row.names.length > 0">
                  <div v-for="name in props.row.names">{{ name.name }}</div>
                </div>
                <div v-else>{{ props.row.name }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="Country"
              :show-overflow-tooltip="true"
              min-width="75"
              ><template slot-scope="props">{{
                props.row.region.name
              }}</template></el-table-column
            >
            <el-table-column
              v-if="!hidePrice && !$store.getters.usesTokens"
              label="Our Price"
              align="right"
              header-align="right"
              min-width="75"
              ><template slot-scope="props">{{
                formatMoney(props.row.product ? props.row.product.price : null)
              }}</template></el-table-column
            >
            <el-table-column
              v-if="!hidePrice && !$store.getters.usesTokens"
              label="Institute Surcharge"
              align="right"
              header-align="right"
              min-width="130"
              ><template slot-scope="props">{{
                formatMoney(props.row.surcharge)
              }}</template></el-table-column
            >
            <el-table-column
              v-if="!hidePrice && !$store.getters.usesTokens"
              label="Total"
              align="right"
              header-align="right"
              min-width="75"
              ><template slot-scope="props">{{
                formatMoney(props.row.totalPrice)
              }}</template></el-table-column
            >
            <el-table-column
              v-if="!hidePrice && $store.getters.usesTokens"
              label="Credits"
              align="right"
              header-align="right"
              min-width="75"
              ><template slot-scope="props">{{
                formatCreditTokens(props.row.totalPrice)
              }}</template></el-table-column
            >
            <el-table-column
              v-if="results.length == 1"
              label="Select"
              align="right"
              header-align="right"
              ><template>
                <button
                  v-if="this.selectionWarning"
                  class="btn btn-danger btn-xs"
                >
                  SELECT
                </button>
                <button v-else class="btn btn-default btn-xs">SELECT</button>
              </template></el-table-column
            >
          </el-table>
        </transition>
      </div>
      <div
        v-if="results && results.length > 0"
        class="col-sm-6 pagination-info"
      >
        <p class="category">
          Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        </p>
      </div>
      <div v-if="results && results.length > 0" class="col-sm-6">
        <p-pagination
          class="pull-right"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="pagination.total"
        >
        </p-pagination>
      </div>
    </div>
  </div>
</template>
<style>
.transition-box {
  margin-bottom: 10px;
  width: 200px;
  height: 100px;
  border-radius: 4px;
  background-color: #409eff;
  text-align: center;
  color: #fff;
  padding: 40px 20px;
  box-sizing: border-box;
  margin-right: 20px;
}
.warning {
  border: 1px solid red;
}
</style>
<script>
import _ from "lodash";
import accounting from "accounting";
import PPagination from "src/components/Pagination.vue";
import ModalInstituteRequest from "src/components/ModalPlugin/ModalInstituteRequest";

accounting.settings.currency.symbol = "£";

export default {
  name: "institute-table",
  components: {
    PPagination,
  },
  props: {
    query: { type: String, default: null },
    region: { type: Object, default: null },
    hidePrice: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      paging: false,
      fuzzy: false,
      total: 0,
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      foundNone: false,
      results: [],
      selectionWarning: false,
    };
  },
  created() {
    if (this.$route.query.institute) {
      this.$store.commit("setInitInstitute", this.$route.query.institute);
      this.$route.query.institute = null;
    }
    this.$store.commit("setSelectionWarning", false);
  },
  mounted() {
    if (this.$store.state.initInstitute) {
      this.$emit("selectInstitute", this.$store.state.initInstitute);
      this.$store.commit("setInitInstitute", false);
    }
    if (this.query || this.region) {
      this.doSearchInstitutes();
    }
    this.selectionWarning = this.$store.state.selectionWarning;
  },
  activated() {
    if (this.$store.state.initInstitute) {
      this.$emit("selectInstitute", this.$store.state.initInstitute);
      this.$store.commit("setInitInstitute", null);
    }
  },
  watch: {
    query(value) {
      this.searchInstitutes();
    },
    region(value) {
      this.doSearchInstitutes();
    },
    paginationCurrentPage(value) {
      this.doSearchInstitutes();
    },
    paginationPerPag(value) {
      this.doSearchInstitutes();
    },
    getSelectionWarning(newVal) {
      this.selectionWarning = newVal;
      this.doSearchInstitutes();
    },
  },
  computed: {
    getSelectionWarning() {
      return this.$store.state.selectionWarning;
    },
    paginationCurrentPage() {
      return this.pagination.currentPage;
    },
    paginationPerPag() {
      return this.pagination.perPage;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
  },
  methods: {
    formatMoney(value) {
      if (!value || value == 0) {
        return "-";
      }
      return accounting.formatMoney(value);
    },
    formatCreditTokens(value) {
      if (!value || value == 0) {
        return "-";
      }
      return accounting.formatMoney(value, "", 0);
    },
    searchInstitutes: _.debounce(function() {
      this.doSearchInstitutes();
    }, 500),
    doSearchInstitutes() {
      this.loading = true;
      this.foundNone = false;
      this.fuzzy = false;
      let instituteSummaryRequest = {
        page: this.pagination.currentPage - 1,
        size: 20,
        name: this.query,
        regionId: this.region ? this.region.id : null,
      };
      this.$api
        .searchInstituteSummary(instituteSummaryRequest)
        .then((response) => {
          this.foundNone = response.data.totalSize == 0;
          this.results = response.data.content;
          this.pagination.total = response.data.totalSize;
          this.total = response.data.totalSize;
          this.loading = false;
        });
      // this.$api.searchInstituteSummary(instituteSummaryRequest)
      //   .then(response => {
      //     if(response.data.totalSize == 0) {
      //       this.fuzzy = true
      //       instituteSummaryRequest.fuzzy = true
      //       this.$api.searchInstituteSummary(instituteSummaryRequest)
      //         .then(response => {
      //           this.foundNone = response.data.totalSize == 0
      //           this.results = response.data.content
      //           this.pagination.total = response.data.totalSize
      //           this.total = response.data.totalSize
      //           this.loading = false
      //         })
      //     } else {
      //       this.results = response.data.content
      //       this.pagination.total = response.data.totalSize
      //       this.total = response.data.totalSize
      //       this.loading = false
      //     }
      //   })
    },
    async selectByRow(currentRow, oldRow) {
      if (currentRow) {
        this.$emit("selectInstitute", currentRow.id);
        this.$refs.instituteTable.setCurrentRow();
      }
    },
    requestInstitute() {
      this.$modal.show(ModalInstituteRequest, {
        nameInit: this.query,
        countryInit: this.region ? this.region.name : null,
      });
    },
  },
};
</script>
